import type { SportsMyBetsState } from './types';

export const defaultState: SportsMyBetsState = {
  bets: [],
  pollingInterval: Infinity,
  cashOutQuotes: {},
  cashedOut: {},
  showLoader: false,
  moreAvailable: false,
  numberOfMatches: 0,
  isErroneous: false,
  cashOutBets: {},
  isLoadingMoreBets: false
};
